import { assign, find } from 'lodash'

import HTTP from '@/common/HTTP'
import { mutationTypes, actionTypes } from './DeficienciesTypes'

function initialState() {
  return {
    items: [],
    editedItem: null,
    loading: false,
  }
}

const mutations = {
  [mutationTypes.SET_DEFICIENCIES](state, items) {
    state.items = items
  },

  [mutationTypes.SET_EDITED_DEFICIENCY](state, auditObject) {
    state.editedItem = auditObject
  },

  [mutationTypes.SET_DEFICIENCY](state, auditObject) {
    assign(find(state.items, { id: auditObject.id }), auditObject)
  },

  [mutationTypes.SET_LOADING](state, value) {
    state.loading = value
  },

}

const actions = {
  [actionTypes.FETCH_DEFICIENCIES]({ commit }) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.get('/deficiencies?sort=no,asc').then(({ data: { content } }) => {
      commit(mutationTypes.SET_DEFICIENCIES, content)
      commit(mutationTypes.SET_LOADING, false)
    })
  },

  [actionTypes.CREATE_DEFICIENCY]({ commit }, auditObject) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.post('/deficiencies', auditObject).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      commit(mutationTypes.SET_EDITED_DEFICIENCY, null)
    })
  },

  [actionTypes.DELETE_DEFICIENCY]({ commit, dispatch }, auditObject) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.delete(`/deficiencies/${auditObject.id}`).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      dispatch(actionTypes.FETCH_DEFICIENCIES)
    })
  },

  [actionTypes.UPDATE_DEFICIENCY]({ commit }, auditObject) {
    commit(mutationTypes.SET_LOADING, true)
    return HTTP.patch(`/deficiencies/${auditObject.id}`, auditObject).then(() => {
      commit(mutationTypes.SET_LOADING, false)
      commit(mutationTypes.SET_EDITED_DEFICIENCY, null)
      commit(mutationTypes.SET_DEFICIENCY, auditObject)
    })
  }


}

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/Deficiencies.js